/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApiFromB2BService } from './services/api-from-b-2-b.service';
import { ApiFromBannerService } from './services/api-from-banner.service';
import { ApiFromCouponService } from './services/api-from-coupon.service';
import { ApiFromCovidService } from './services/api-from-covid.service';
import { ApiFromUserService } from './services/api-from-user.service';
import { ApiFromServiceV2VService } from './services/api-from-service-v-2-v.service';
import { ApiFromIdService } from './services/api-from-id.service';
import { ApiFromPaymentService } from './services/api-from-payment.service';
import { ApiFromFeedbackService } from './services/api-from-feedback.service';
import { ApiFromIssueService } from './services/api-from-issue.service';
import { ApiFromAzureService } from './services/api-from-azure.service';
import { ApiFromLinkCardService } from './services/api-from-link-card.service';
import { ApiFromAutopaymentService } from './services/api-from-autopayment.service';
import { ApiFromTicketsService } from './services/api-from-tickets.service';
import { ApiFromPhotoService } from './services/api-from-photo.service';
import { ApiFromPrivService } from './services/api-from-priv.service';
import { ApiFromPushService } from './services/api-from-push.service';
import { ApiFromParkingService } from './services/api-from-parking.service';
import { ApiFromReceiptService } from './services/api-from-receipt.service';
import { ApiFromVreService } from './services/api-from-vre.service';
import { ApiFromTicketService } from './services/api-from-ticket.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApiFromB2BService,
    ApiFromBannerService,
    ApiFromCouponService,
    ApiFromCovidService,
    ApiFromUserService,
    ApiFromServiceV2VService,
    ApiFromIdService,
    ApiFromPaymentService,
    ApiFromFeedbackService,
    ApiFromIssueService,
    ApiFromAzureService,
    ApiFromLinkCardService,
    ApiFromAutopaymentService,
    ApiFromTicketsService,
    ApiFromPhotoService,
    ApiFromPrivService,
    ApiFromPushService,
    ApiFromParkingService,
    ApiFromReceiptService,
    ApiFromVreService,
    ApiFromTicketService,
    ApiConfiguration
  ],
})
export class ApiGenModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiGenModule> {
    return {
      ngModule: ApiGenModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiGenModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiGenModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
